import { render, staticRenderFns } from "./TypeAbsenteeism.vue?vue&type=template&id=67cc3266"
import script from "./TypeAbsenteeism.vue?vue&type=script&lang=js"
export * from "./TypeAbsenteeism.vue?vue&type=script&lang=js"
import style0 from "./TypeAbsenteeism.vue?vue&type=style&index=0&id=67cc3266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports